export const HOME_PATH = '/';
export const USER_DETAILS_PATH = ':userId';
